import { Box } from '@mui/material'
import { AnyPlaybookType, PlaylistType, QuickGuiddeType, VideoOverlayDataType } from 'app/types'
import { VideoPlayer } from 'components'
import { DsComponentDocViewWrapper } from './DsComponentDocViewWrapper'
import { ContentWrapper } from './ContentWrapper'

type Props = {
    videos: Array<AnyPlaybookType>
    overlayData: VideoOverlayDataType
    playlist?: PlaylistType
    currentVideoIndex: number
    playbook: QuickGuiddeType
    onLanguageChange: (_: string) => void
    onChangeActiveVideo: (_: number) => void
}

export const DocViewAndVideoPlayer = ({
    videos,
    overlayData,
    playlist,
    currentVideoIndex,
    playbook,
    onLanguageChange,
    onChangeActiveVideo,
}: Props) => (
    <ContentWrapper
        playbook={playbook}
        onLanguageChange={onLanguageChange}
    >
        <Box
            borderRadius="10px"
            overflow="hidden"
        >
            <VideoPlayer
                videos={videos}
                overlayData={overlayData}
                playlist={playlist}
                currentVideoIndex={currentVideoIndex}
                playbook={playbook}
                onLanguageChange={onLanguageChange}
                onChangeActiveVideo={onChangeActiveVideo}
            />
        </Box>

        <DsComponentDocViewWrapper
            playbook={videos[0] as QuickGuiddeType}
            overlayData={overlayData}
        />
    </ContentWrapper>
)
